module.exports = __webpack_public_path__ + "img/facebookIcon.0e35393.png";